import { render, staticRenderFns } from "./ServerAdd.vue?vue&type=template&id=01e48569&scoped=true&"
import script from "./ServerAdd.vue?vue&type=script&lang=js&"
export * from "./ServerAdd.vue?vue&type=script&lang=js&"
import style0 from "./ServerAdd.vue?vue&type=style&index=0&id=01e48569&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e48569",
  null
  
)

export default component.exports